export const PRIORITY_COLORS = {
  0: '#93c7dc', // Low
  1: '#FFC107', // Medium
  2: '#8BC34A', // Normal
  3: '#FF6E39', // High
  4: '#F44336', // Urgent
};

export const getPriorityColor = (priority) => PRIORITY_COLORS[priority] ?? '#9E9E9E';
